import { NavMenu } from './NavMenu'
import { NavItem } from '../../../../../../shared/components/cards/nav-item/NavItem'
import { ProfileDropdown } from './ProfileDropdown'
import { ProfileDropdownItem } from './ProfileDropdownItem'
import { useWindowSize } from '../../../../../../shared/lib/hooks/UseWindowSize'
import { LogoutIcon } from '../../../../../../shared/components/icons/nav/LogoutIcon'
import { ProfileIcon } from '../../../../../../shared/components/icons/nav/ProfileIcon'
import { NavDropdown } from './NavDropdown'
import { NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '../../../../../../shared/lib/hooks/UseAuth'
import { useMenuLayout } from '../../../hooks/UseMenuLayout'
import { selectTariffDetails, selectUser } from '../../../../../store/reducers/AuthSlice'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks/Redux'
import { NavDropItem } from '../../../../../../shared/components/cards/nav-drop-item/NavDropItem'
import { OrganicResultsIcon } from '../../../../../../shared/components/icons/nav/OrganicResultsIcon'
import { PaidResultsIcon } from '../../../../../../shared/components/icons/nav/PaidResultsIcon'
import { PositionTrackerIcon } from '../../../../../../shared/components/icons/nav/PositionTrackerIcon'
import { AdvertisingResearchIcon } from '../../../../../../shared/components/icons/nav/AdvertisingResearchIcon'
import { NavLinkItem } from '../../../../../../shared/components/cards/nav-link-item/NavLinkItem'
import { NavCollapseItem } from '../../../../../../shared/components/cards/nav-collapse-item/NavCollapseItem'
import { BrandMentionsIcon } from '../../../../../../shared/components/icons/nav/BrandMentionsIcon'
import { UncloakingIcon } from '../../../../../../shared/components/icons/nav/UncloakingIcon'
import { BlackhatMonitoringIcon } from '../../../../../../shared/components/icons/nav/BlackhatMonitoringIcon'
import { useTranslation } from 'react-i18next'
import { AffiliateComplianceIcon } from '../../../../../../shared/components/icons/nav/AffiliateComplianceIcon'
import { NonCompliantContentIcon } from '../../../../../../shared/components/icons/nav/NonCompliantContentIcon'
import { TariffIcon } from '../../../../../../shared/components/icons/nav/TariffIcon'
import React from 'react'
import { setModal } from '../../../../../store/reducers/AppSlice'
import { TeamIcon } from '../../../../../../shared/components/icons/nav/TeamIcon'
import { HelpButton } from './HelpButton'
import { ViewGuard } from '../../../../../guards/ViewGuard'
import { ChangeTariff } from '../../../../../../shared/components/utility/change-tariff/ChangeTariff'
import { TariffDetailsModal } from '../../../../../../pages/projects/widgets/tariff-details-modal/TariffDetailsModal'
import { EarnIcon } from '../../../../../../shared/components/icons/nav/EarnIcon'
import { SidebarIcon } from '../../../../../../shared/components/icons/nav/SidebarIcon'
import { TrademarkInfringementsIcon } from '../../../../../../shared/components/icons/nav/TrademarkInfringementsIcon'

export const Header = () => {
  const { t } = useTranslation()
  const { xs, sm, xl } = useWindowSize()
  const user = useAppSelector(selectUser)
  const tariffDetails = useAppSelector(selectTariffDetails)
  const { logout } = useAuth()
  const { switchMenuLayout } = useMenuLayout()
  const { pathname } = useLocation()
  const dispatch = useAppDispatch()

  return (
    <div className='relative flex items-center gap-[16px]'>
      <NavLink to={`${['editor', 'admin'].includes(user.sub_role) ? '/projects' : '/ad-reports'}`}>
        <img alt='logo' className='w-[111px] cursor-pointer' src={'/logo.svg'} />
      </NavLink>
      {xl && (
        <div className='flex-1'>
          <NavMenu>
            <ViewGuard roles={['editor', 'admin']}>
              <NavLink end to='/projects'>
                {({ isActive }) => (
                  <NavItem active={isActive} size={'sm'}>
                    {t('navigation.projects')}
                  </NavItem>
                )}
              </NavLink>
            </ViewGuard>
            <NavDropItem
              active={['/ad-reports', '/organic-results', '/live-search'].includes(pathname)}
              label={t('navigation.SERPMonitoring')}
            >
              <NavLinkItem icon={<PaidResultsIcon />} to='/ad-reports'>
                {t('navigation.paidSearch')}
              </NavLinkItem>
              <NavLinkItem icon={<OrganicResultsIcon />} to='/organic-results'>
                {t('navigation.organicSearch')}
              </NavLinkItem>
            </NavDropItem>
            <NavDropItem
              active={['/ppc-compliance', '/language-compliance-page', '/tm-infringement'].includes(
                pathname,
              )}
              label={t('navigation.brandProtection')}
            >
              <NavLinkItem icon={<AffiliateComplianceIcon />} to='/ppc-compliance'>
                {t('navigation.affiliateCompliance')}
              </NavLinkItem>
              <NavLinkItem
                hidden={!user.tm_infringements_enabled}
                icon={<TrademarkInfringementsIcon />}
                to='/tm-infringement'
              >
                {t('navigation.trademarkInfringements')}
              </NavLinkItem>
              <NavLinkItem icon={<NonCompliantContentIcon />} to='/language-compliance-page'>
                {t('navigation.nonCompliantContent')}
              </NavLinkItem>
            </NavDropItem>
            <NavDropItem
              active={['/position-tracker', '/serp-presence', '/advertising-research'].includes(
                pathname,
              )}
              label={t('navigation.moreTools')}
            >
              <p className={'pointer-events-none pl-[8px] text-[12px] text-[#6684A7]'}>
                {t('navigation.researchTools')}
              </p>
              <NavLinkItem icon={<PositionTrackerIcon />} to='/position-tracker'>
                {t('navigation.SEOPositionTracker')}
              </NavLinkItem>
              <NavLinkItem icon={<BrandMentionsIcon />} to='/serp-presence'>
                {t('navigation.onSiteBrandMentions')}
              </NavLinkItem>
              <NavLinkItem icon={<AdvertisingResearchIcon />} to='/advertising-research'>
                {t('navigation.advertisingResearch')}
              </NavLinkItem>
              <p
                className={`pointer-events-none pl-[8px] pt-[8px] text-[12px] text-[#6684A7] ${!user.allow_decloak_live && !user.allow_decloak_auto && 'hidden'}`}
              >
                {t('navigation.uncloaking')}
              </p>
              <NavLinkItem
                hidden={!user.allow_decloak_live}
                icon={<UncloakingIcon />}
                to='/live-uncloaking'
              >
                {t('navigation.liveUncloaking')}
              </NavLinkItem>
              <NavLinkItem
                hidden={!user.allow_decloak_auto}
                icon={<BlackhatMonitoringIcon />}
                to='/blackhat-monitoring'
              >
                {t('navigation.blackhatMonitoring')}
              </NavLinkItem>
            </NavDropItem>
            <NavLink end to='/referral-program'>
              {({ isActive }) => (
                <NavItem
                  active={isActive}
                  hidden={process.env.REACT_APP_PROJECT === 'robuscan'}
                  icon={EarnIcon}
                  size={'sm'}
                >
                  {t('navigation.earn')}
                </NavItem>
              )}
            </NavLink>
          </NavMenu>
        </div>
      )}

      <div className='ml-auto flex w-[calc(100%-127px)] justify-end gap-[16px] md:w-auto'>
        <ViewGuard roles={['editor', 'admin']}>
          {tariffDetails?.tariff && (
            <button
              onClick={() =>
                tariffDetails.tariff?.is_subscription_expired
                  ? dispatch(
                      setModal({
                        size: 'full',
                        children: <ChangeTariff />,
                        withBackButton: true,
                      }),
                    )
                  : dispatch(
                      setModal({
                        children: <TariffDetailsModal />,
                      }),
                    )
              }
            >
              <div
                className={`flex h-[38px] w-[38px] items-center justify-center gap-[6px] rounded-full md:h-[32px] md:w-auto md:px-[12px] ${tariffDetails.tariff.is_subscription_expired ? 'bg-[#FF4980]' : 'bg-white'} `}
              >
                <span
                  className={
                    tariffDetails.tariff.is_subscription_expired ? 'text-white' : 'text-default'
                  }
                >
                  <TariffIcon />
                </span>
                <span
                  className={`hidden whitespace-nowrap font-medium md:block ${
                    tariffDetails.tariff.is_subscription_expired ? 'text-white' : 'text-default'
                  }`}
                >
                  {tariffDetails.tariff.is_subscription_expired
                    ? t('pages.tariff.planExpired')
                    : tariffDetails.tariff.type === 'custom'
                      ? t('pages.tariff.customPlan')
                      : tariffDetails.tariff.name}
                </span>
              </div>
            </button>
          )}
        </ViewGuard>
        <HelpButton />
        <ProfileDropdown>
          <NavLink to='/profile-settings'>
            <ProfileDropdownItem icon={<ProfileIcon />}>
              {t('pages.profile.profile')}
            </ProfileDropdownItem>
          </NavLink>
          <ViewGuard roles={['admin']}>
            <NavLink to='/team'>
              <ProfileDropdownItem icon={<TeamIcon />}>
                {t('pages.profile.team')}
              </ProfileDropdownItem>
            </NavLink>
          </ViewGuard>
          <ProfileDropdownItem
            icon={<SidebarIcon width={16} />}
            onClick={() => switchMenuLayout('sidebar')}
          >
            Switch to sidebar menu
          </ProfileDropdownItem>
          <ProfileDropdownItem icon={<LogoutIcon />} onClick={() => logout()}>
            {t('pages.profile.logout')}
          </ProfileDropdownItem>
        </ProfileDropdown>
        {!xl && (
          <div className='z-10'>
            <NavDropdown>
              <ViewGuard roles={['editor', 'admin']}>
                <NavLink end to='/projects'>
                  {({ isActive }) => (
                    <NavItem active={isActive} decoration='dot' size='md' theme='dark'>
                      {t('navigation.projects')}
                    </NavItem>
                  )}
                </NavLink>
              </ViewGuard>
              <NavCollapseItem
                active={['/ad-reports', '/organic-results', '/live-search'].includes(pathname)}
                decoration='dot'
                label={t('navigation.SERPMonitoring')}
                size='sm'
                theme='dark'
              >
                <NavLinkItem icon={<PaidResultsIcon />} to='/ad-reports'>
                  {t('navigation.paidSearch')}
                </NavLinkItem>
                <NavLinkItem icon={<OrganicResultsIcon />} to='/organic-results'>
                  {t('navigation.organicSearch')}
                </NavLinkItem>
              </NavCollapseItem>
              <NavCollapseItem
                active={[
                  '/ppc-compliance',
                  '/language-compliance-page',
                  '/tm-infringement',
                ].includes(pathname)}
                decoration='dot'
                label={t('navigation.brandProtection')}
                size='sm'
                theme='dark'
              >
                <NavLinkItem icon={<AffiliateComplianceIcon />} to='/ppc-compliance'>
                  {t('navigation.affiliateCompliance')}
                </NavLinkItem>
                <NavLinkItem
                  hidden={!user.tm_infringements_enabled}
                  icon={<TrademarkInfringementsIcon />}
                  to='/tm-infringement'
                >
                  {t('navigation.trademarkInfringements')}
                </NavLinkItem>
                <NavLinkItem icon={<NonCompliantContentIcon />} to='/language-compliance-page'>
                  {t('navigation.nonCompliantContent')}
                </NavLinkItem>
              </NavCollapseItem>
              <NavCollapseItem
                active={['/position-tracker', '/serp-presence', '/advertising-research'].includes(
                  pathname,
                )}
                decoration='dot'
                label={t('navigation.moreTools')}
                size='sm'
                theme='dark'
              >
                <p className={'pointer-events-none pl-[8px] text-[12px] text-[#6684A7]'}>
                  {t('navigation.researchTools')}
                </p>
                <NavLinkItem icon={<PositionTrackerIcon />} to='/position-tracker'>
                  {t('navigation.SEOPositionTracker')}
                </NavLinkItem>
                <NavLinkItem icon={<BrandMentionsIcon />} to='/serp-presence'>
                  {t('navigation.onSiteBrandMentions')}
                </NavLinkItem>
                <NavLinkItem icon={<AdvertisingResearchIcon />} to='/advertising-research'>
                  {t('navigation.advertisingResearch')}
                </NavLinkItem>
                <p
                  className={`pointer-events-none pl-[8px] pt-[8px] text-[12px] text-[#6684A7] ${!user.allow_decloak_live && !user.allow_decloak_auto && 'hidden'}`}
                >
                  {t('navigation.uncloaking')}
                </p>
                <NavLinkItem
                  hidden={!user.allow_decloak_live}
                  icon={<UncloakingIcon />}
                  to='/live-uncloaking'
                >
                  {t('navigation.liveUncloaking')}
                </NavLinkItem>
                <NavLinkItem
                  hidden={!user.allow_decloak_auto}
                  icon={<BlackhatMonitoringIcon />}
                  to='/blackhat-monitoring'
                >
                  {t('navigation.blackhatMonitoring')}
                </NavLinkItem>
              </NavCollapseItem>
              <NavLink end to='/referral-program'>
                {({ isActive }) => (
                  <NavItem
                    active={isActive}
                    decoration='dot'
                    hidden={process.env.REACT_APP_PROJECT === 'robuscan'}
                    icon={EarnIcon}
                    size='md'
                    theme='dark'
                  >
                    {t('navigation.earn')}
                  </NavItem>
                )}
              </NavLink>
            </NavDropdown>
          </div>
        )}
      </div>
    </div>
  )
}
